module.exports = __webpack_public_path__ + "static/img/privacy_img_append3.7c5cbd86.png";